import { useEffect } from 'react';

import { useHasLoggedOut } from '../../context/AuthMachine';
import { useGlobalAppState } from '../../context/GlobalAppState';

// ────────────────────────────────────────────────────────────────────────────────

export const useResetDietaryRestrictionsOnLogout = () => {
  const hasLoggedOut = useHasLoggedOut();

  const { dietaryRestrictionsMachineRef: actor } = useGlobalAppState();

  useEffect(() => {
    if (!hasLoggedOut) return;

    actor.send({ type: 'RESET' });
  }, [hasLoggedOut, actor]);
};
